document.addEventListener("DOMContentLoaded", function () {
    const resultContainer = document.getElementById("ajax-results-container");
    const submitFilter = document.getElementById("filter__submit");
    const termsJson = resultContainer.getAttribute("data-terms");
    const termsArray = JSON.parse(termsJson);
    const termInputs = {};
    const url = document.getElementById("url-input").value;
    //consts for filter toggle
    const spans = document.querySelectorAll(".filter__pill span");
    const formfilter = document.getElementById("formfilter");
    const filters = document.querySelector(".filter__container");
    const pillContainer = document.querySelector(".filter__pill-container");

    termsArray.forEach((term) => {
        // Convert hyphenated term to camelCase for key name
        // const camelCaseTerm = term.replace(/[-_]([a-z])/g, (_, letter) => letter.toUpperCase());
        const camelCaseTerm = term;
        // Store NodeList in object
        termInputs[`${camelCaseTerm}`] = document.querySelectorAll(`.js-${term}`);
    });

    function getChecked(inputs) {
        return Array.from(inputs)
            .filter((input) => input.checked)
            .map((input) => ({
                slug: input.name,
                id: input.value,
                label: input.dataset.label,
            }));
    }

    function ajaxFilterResources(paged = 1, scrollToAnchor = false) {
        const tax = document.getElementById("tax-input").value;
        // const pages = document.getElementById("paged-input").value;
        const value = document.getElementById("search__input").value;
        const taxonomy = document.getElementById("taxonomy-input").value;
        const postType = document.getElementById("postType-input").value;
        let taxNames = [];

        const data = new FormData();
        data.append("action", "filter_resources");
        data.append("paged", paged);
        data.append("url", url);
        data.append("taxonomy", taxonomy);
        data.append("postType", postType);

        for (const [key, inputs] of Object.entries(termInputs)) {
            const checkedValues = getChecked(inputs).map((item) => item.id);

            data.append(key, checkedValues);
            taxNames.push(key);
        }

        data.append("taxNames", JSON.stringify(taxNames));

        if (value.length >= 1) {
            data.append("search", value);
        }
        if (tax.length >= 1) {
            data.append("tax", tax);
        }

        fetch(site_data.adminajax, {
            method: "POST",
            body: data,
        })
            .then((response) => response.text())
            .then((html) => {
                window.history.pushState({}, "", url);
                resultContainer.innerHTML = html;

                if (scrollToAnchor) {
                    const anchor = document.getElementById("filter-anchor");
                    if (anchor) {
                        const images = resultContainer.querySelectorAll("img");

                        const doScroll = () => {
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    const top = anchor.getBoundingClientRect().top + window.scrollY;
                                    window.scrollTo({ top, behavior: "smooth" });
                                });
                            });
                        };

                        if (images.length === 0) {
                            doScroll();
                        } else {
                            let scrolled = false;
                            const startTime = performance.now();

                            const safeScroll = (reason) => {
                                if (scrolled) return;
                                scrolled = true;
                                clearTimeout(timeout);
                                window.console.log(
                                    `Scroll triggered via [${reason}] after ${Math.round(performance.now() - startTime)}ms`,
                                );
                                doScroll();
                            };

                            // Only watch images in the top portion of the result container
                            // These are the ones that affect the anchor's getBoundingClientRect position
                            const viewportHeight = window.innerHeight;
                            // const aboveFoldImages = Array.from(images).filter((img) => {
                            //     const rect = img.getBoundingClientRect();
                            //     return rect.top < viewportHeight * 2; // within 2 viewports from top
                            // });
                            const aboveFoldImages = Array.from(images).filter((img) => {
                                const rect = img.getBoundingClientRect();
                                const absoluteTop = rect.top + window.scrollY;
                                return absoluteTop < viewportHeight * 2; // within 2 viewports from top of document
                            });

                            if (aboveFoldImages.length === 0) {
                                safeScroll("no above-fold images");
                            } else {
                                let settled = 0;
                                let timeout; // declare first

                                const safeScroll = (reason) => {
                                    if (scrolled) return;
                                    scrolled = true;
                                    clearTimeout(timeout);
                                    console.log(
                                        `Scroll triggered via [${reason}] after ${Math.round(performance.now() - startTime)}ms`,
                                    );
                                    doScroll();
                                };

                                const onSettle = () => {
                                    settled++;
                                    if (settled === aboveFoldImages.length)
                                        safeScroll(`all ${settled} above-fold images settled`);
                                };

                                timeout = setTimeout(() => safeScroll("timeout"), 2000); // assign after declaration

                                aboveFoldImages.forEach((img) => {
                                    if (img.complete) {
                                        onSettle();
                                    } else {
                                        img.addEventListener("load", onSettle);
                                        img.addEventListener("error", onSettle);
                                    }
                                });
                            }
                        }
                    }
                } else {
                    resultContainer.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            })
            .catch((err) => window.console.error(err));
    }

    // Listen for checkbox changes if you want to it every click of checkbox
    // Object.values(termInputs).forEach((inputs) => {
    //     inputs.forEach((input) => {
    //         input.addEventListener("change", () => ajaxFilterResources());
    //     });
    // });

    pillContainer.addEventListener("click", (event) => {
        const span = event.target.closest("span"); // only respond if a span was clicked
        if (!span) return;

        const parent = span.parentElement;

        // Get its data-value attribute
        const value = parent.getAttribute("data-slug");

        // Uncheck checkbox filter and remove pill
        const checkbox = document.querySelector(`input[type="checkbox"][name="${value}"]`);
        if (checkbox) checkbox.checked = false;
        parent.remove();

        ajaxFilterResources();
    });

    // Listen for done button to click
    document.getElementById("formfilter").addEventListener("submit", function (e) {
        e.preventDefault(); // stop form from submitting normally
        pillContainer.innerHTML = "";
        for (const [key, inputs] of Object.entries(termInputs)) {
            const checkedName = getChecked(inputs).map((item) => item.label);
            const checkedValue = getChecked(inputs).map((item) => item.id);
            const checkedSlug = getChecked(inputs).map((item) => item.slug);

            if (checkedName.length > 0) {
                checkedName.forEach(function (element, index) {
                    const div = document.createElement("div");
                    const span = document.createElement("span");

                    span.textContent = "\u2715"; // Multiplication X (thin)
                    div.classList.add("filter__pill");
                    div.textContent = element;
                    div.setAttribute("data-value", checkedValue[index]);
                    div.setAttribute("data-slug", checkedSlug[index]);
                    div.setAttribute("style", "background-color: var(--tertiary);");
                    div.appendChild(span);

                    pillContainer.appendChild(div);
                });
            }
        }
        ajaxFilterResources();

        //if you want to close on submit
        formfilter.style.height = "0px";
        formfilter.classList.toggle("open");
        const filter__formcontainer = document.querySelector(".filter__form-container");
        const filter__toggle = document.querySelector(".filter__toggle");
        const filterBurger = document.querySelector(".filter__burger");
        filter__toggle.classList.toggle("open");
        filterBurger.classList.toggle("active");
        setTimeout(() => {
            filter__formcontainer.classList.toggle("open");
        }, 200);
    });

    //pagination
    const resourcesResults = document.querySelector("#ajax-results-container");

    // Delegate clicks on pagination links
    document.addEventListener("click", (e) => {
        const link = e.target.closest(".postnavigation a");
        if (!link) return;

        e.preventDefault();

        const pageurl = link.getAttribute("href");
        const match = pageurl.match(/\/page\/(\d+)/);
        const pageNum = match ? parseInt(match[1], 10) : 1;

        resourcesResults.classList.add("loading");
        ajaxFilterResources(pageNum, true); // true = scroll to #filter-anchor after load
    });

    // Handle back/forward navigation
    window.addEventListener("popstate", () => {
        fetch(location.href)
            .then((res) => res.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, "text/html");

                const newContent = doc.querySelector("#ajax-results").innerHTML;
                resourcesResults.innerHTML = newContent;
            })
            .catch((err) => console.error("Popstate Error:", err));
    });

    //search
    document.getElementById("search").addEventListener("submit", function (e) {
        e.preventDefault(); // stop form from submitting normally
        ajaxFilterResources();
    });

    //filter toggle panel open
    document.body.addEventListener("click", (event) => {
        const filterBurger = document.querySelector(".filter__burger");

        if (event.target.id === "filter__toggle") {
            event.preventDefault();

            filterBurger.classList.toggle("active");

            let newHeight = filters.offsetHeight + 68;

            if (!formfilter.classList.contains("open")) {
                formfilter.style.height = newHeight + "px";
                formfilter.classList.toggle("open");
                event.target.classList.toggle("open");
                event.target.parentElement.classList.toggle("open");
            } else {
                formfilter.style.height = "0px";
                formfilter.classList.toggle("open");
                event.target.classList.toggle("open");
                setTimeout(() => {
                    event.target.parentElement.classList.toggle("open");
                }, 200);
            }
        }
    });
});
